import React from 'react';
import { TrendingUpIcon, UsersIcon, DollarSignIcon, CheckCircleIcon } from 'lucide-react';
import { AnimatedMetric } from '../ui/AnimatedMetric';
export function ResultsSummary() {
  const metrics = [{
    icon: UsersIcon,
    value: 3000,
    suffix: '+',
    label: 'Reps Hired with the HIRE Advantage system',
    sublabel: '(Across all client companies)'
  }, {
    icon: DollarSignIcon,
    value: 150,
    suffix: 'M+',
    prefix: '$',
    label: 'Production from Hired Reps',
    sublabel: '(By HIRE-recruited teams)'
  }, {
    icon: TrendingUpIcon,
    value: 45,
    suffix: '%',
    label: 'Better Retention',
    sublabel: '(Compared to baseline)'
  }, {
    icon: CheckCircleIcon,
    value: 85,
    suffix: '%',
    prefix: '+',
    label: 'Client Retention',
    sublabel: '(Based on internal survey)'
  }];
  return <section className="section-padding bg-gray-50" data-id="element-893">
      <div className="container-custom" data-id="element-894">
        <div className="max-w-5xl mx-auto" data-id="element-895">
          <div className="text-center mb-12 md:mb-16" data-id="element-896">
            <h2 className="mb-4" data-id="element-897">Proven Results Across Markets</h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-898">
            {metrics.map((metric, index) => {
            const Icon = metric.icon;
            return <div key={index} className="bg-white rounded-xl p-6 md:p-8 shadow-lg border-2 border-gray-200 text-center" data-id="element-899">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-slate/10 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-900">
                    <Icon className="h-6 w-6 md:h-7 md:w-7 text-slate" data-id="element-901" />
                  </div>
                  <div className="text-3xl md:text-4xl font-bold text-navy mb-2" data-id="element-902">
                    <AnimatedMetric value={metric.value} prefix={metric.prefix} suffix={metric.suffix} duration={2000} data-id="element-903" />
                  </div>
                  <p className="font-semibold mb-1" data-id="element-904">{metric.label}</p>
                  <p className="text-xs text-gray-600" data-id="element-905">{metric.sublabel}</p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}